/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const HierarchyIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 70 73"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2" transform="translate(1.25 1.5)">
        <circle cx="33.75" cy="8.367" r="8.322" />
        <path d="M47.064 30H20.436c0-7.347 5.958-13.314 13.314-13.314 7.359 0 13.314 5.967 13.314 13.314z" />
        <circle cx="11.127" cy="52.374" r="6" />
        <path d="M21.762 69.006H.492c0-5.874 4.758-10.632 10.635-10.632 5.874 0 10.635 4.758 10.635 10.632z" />
        <circle cx="56.127" cy="52.374" r="6" />
        <path d="M66.762 69.006h-21.27c0-5.874 4.758-10.632 10.635-10.632 5.874 0 10.635 4.758 10.635 10.632z" />
        <circle cx="56.127" cy="52.374" r="6" />
        <path d="M66.762 69.006h-21.27c0-5.874 4.758-10.632 10.635-10.632 5.874 0 10.635 4.758 10.635 10.632z" />
        <circle cx="33.75" cy="52.374" r="6" />
        <path d="M44.385 69.006H23.118c0-5.874 4.758-10.632 10.632-10.632 5.877 0 10.635 4.758 10.635 10.632zM11.25 38.937V36h45v2.937M33.75 30v8.937" />
      </g>
    </g>
  </svg>
);

export default HierarchyIcon;
